// @flow
import { Box, Button } from 'grommet';
import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { isEmpty } from 'lodash';
import styled from 'styled-components';
import { LinkTop } from 'grommet-icons';
import { getPendingAction } from 'esm-web-pro/redux/confirmations';
import { hasOpenedPanels as hasOpenedPanelsSelector } from 'esm-web-pro/redux/side-panel/selectors';
import {
    closeConfirmation as closeConfirmationAction, proceed as proceedAction,
} from 'esm-web-pro/redux/confirmations/actions';
import LeavePageDialog from 'esm-web-pro/components/dialogs/LeavePageDialog';
import { SIDE_PANEL_CONFIRMATION_CATEGORY } from 'esm-web-pro/redux/side-panel/constants';
import 'react-resizable/css/styles.css';
import { ResizableBox } from 'react-resizable';
import 'esm-web-pro/assets/styles/resizable.css';
import SidePaneContext from './context/SidePaneContext';


type SidePanelReduxProps = {
    pendingAction: {
        action: Object,
        confirmation: {
            message: string,
        },
    } | {},
    closeConfirmation: Function,
    proceed: Function,
    hasOpenedPanels: boolean,
}

type Props = {
    ...$Exact<SidePanelReduxProps>,
    children: React.Node,
}

type State = {
    closed: boolean;
    count: number,
    size: number | null,
}

const StyledBox = styled(Box)`
    position: absolute;
    min-height: 100%;
    box-shadow: 2px -2px 23px -6px #CCCCCC;
    display: block;
`;

const ChildrenBox = styled(Box)`
    z-index: 1;
`;

const mapStateToProps = (state) => ({
    pendingAction: getPendingAction(state, SIDE_PANEL_CONFIRMATION_CATEGORY),
    hasOpenedPanels: hasOpenedPanelsSelector(state),
});

const mapDispatchToProps = (dispatch) => (bindActionCreators({
    closeConfirmation: closeConfirmationAction,
    proceed: proceedAction,
}, dispatch));

@connect(mapStateToProps, mapDispatchToProps)
class SidePaneContainer extends React.Component<Props, State> {
    state = {
        closed: false,
        count: 0,
        size: localStorage.getItem('panelSize') ? Number(localStorage.getItem('panelSize')) : 400,
    };

    togglePanel = (closed: ?boolean = null) => {
        if (typeof closed === 'boolean') {
            this.setState({ closed });
        } else {
            this.setState((oldState) => ({
                closed: !oldState.closed,
            }));
        }
    };

    setCount = (count: number) => {
        this.setState((oldState) => ({
            count: oldState.count + count,
            closed: oldState.count + count === 0 ? false : oldState.closed,
        }));
    };

    render() {
        const {
            children, pendingAction, proceed, closeConfirmation, hasOpenedPanels,
        } = this.props;
        const { closed, count, size } = this.state;

        return (
            <SidePaneContext.Provider
                value={{
                    closed,
                    togglePanel: this.togglePanel,
                    count,
                    setCount: this.setCount,
                    size,
                }}
            >
                {!isEmpty(pendingAction) && (
                    <LeavePageDialog
                        // $FlowFixMe pendingAction is checked if it is empty above
                        message={pendingAction.confirmation.message}
                        onClose={() => closeConfirmation(SIDE_PANEL_CONFIRMATION_CATEGORY)}
                        onProceed={() => proceed(SIDE_PANEL_CONFIRMATION_CATEGORY, pendingAction)}
                    />
                )}
                <ChildrenBox width="100%">
                    {children}
                </ChildrenBox>
                <ResizableBox
                    id="side-pane"
                    width={hasOpenedPanels ? size : 0}
                    axis="x"
                    // height={window.innerHeight - 60}
                    resizeHandles={['w']}
                    minConstraints={[350]}
                    maxConstraints={[700]}
                    onResize={(evt, { size: _s }) => this.setState({ size: _s.width })}
                    onResizeStop={(evt, { size: _s }) => localStorage.setItem('panelSize', _s.width)}
                    style={{ flexShrink: 0 }}
                >
                    {
                        closed ? (
                            <>
                                <Box width="61px" />
                                <StyledBox
                                    height="100%"
                                    background={{ color: 'white' }}
                                    animation="slideLeft"
                                    border={{ side: 'left', color: '#CCCCCC', zIndex: '1' }}
                                    style={{ right: '0px', display: 'flex', alignItems: 'center' }}
                                    width="61px"
                                >
                                    <Button
                                        style={{
                                            position: 'absolute',
                                            transform: 'rotate(-90deg)',
                                            top: '6px',
                                            alignSelf: 'center',
                                        }}
                                        icon={<LinkTop />}
                                        onClick={this.togglePanel}
                                        hoverIndicator
                                    />
                                </StyledBox>
                            </>
                        ) : null
                    }
                </ResizableBox>
            </SidePaneContext.Provider>
        );
    }
}

export default SidePaneContainer;
